import { useState, useCallback } from "react";

export function useForm(initialValues = { title: "", description: "" }) {
  const [title, setTitle] = useState(initialValues.title);
  const [description, setDescription] = useState(initialValues.description);

  const handleUpdateFormValues = useCallback(
    ({ title, description }) => {
      setTitle(title);
      setDescription(description);
    },
    [setTitle, setDescription]
  );

  const handleChangeTitle = useCallback((value) => setTitle(value), []);
  const handleChangeDescription = useCallback(
    (e) => setDescription(e.target.value),
    []
  );

  const handleClearForm = useCallback(() => {
    setTitle("");
    setDescription("");
  }, []);

  const form = {
    title: {
      value: title,
      onChange: handleChangeTitle,
    },
    description: {
      value: description,
      onChange: handleChangeDescription,
    },
  };

  return {
    title,
    setTitle,
    description,
    setDescription,
    handleUpdateFormValues,
    form,
    handleClearForm,
  };
}
